import { ShieldCheck, Award, Globe, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E2DDD5] bg-[#1E3A2B] text-[#FAF8F5]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-14 rounded-full bg-[#D97706]" />
            <div>
              <div className="font-serif text-3xl font-bold leading-tight">Healthion India</div>
              <div className="text-[11px] font-mono tracking-wider opacity-70 mt-1">BY AMIROOP HEALTHION LLP · A CURATED AYURVEDA MARKETPLACE</div>
            </div>
          </div>
          <p className="mt-4 text-sm opacity-80 max-w-md leading-relaxed">
            Healthion India is a verified multi-vendor marketplace platform operated by <strong>Amiroop Healthion LLP</strong>. We do not manufacture — we curate, verify, and market authentic Ayurvedic products from licensed Indian brands. Founded by <strong>Dr. Rupali Srivastava</strong> (Dietitian &amp; Nutritionist) &amp; <strong>Amit Kumar Srivastava</strong>.
          </p>

          <div className="mt-6 space-y-2 text-sm">
            <a href="https://www.healthionindia.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#D97706]" data-testid="footer-website">
              <Globe className="w-4 h-4 text-[#D97706]" /> www.healthionindia.com
            </a>
            <a href="mailto:care@healthioindia.com" className="flex items-center gap-2 hover:text-[#D97706]" data-testid="footer-email">
              <Mail className="w-4 h-4 text-[#D97706]" /> care@healthioindia.com
            </a>
            <a href="tel:+917080800384" className="flex items-center gap-2 hover:text-[#D97706]" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-[#D97706]" /> +91 70808 00384
            </a>
          </div>

          <div className="mt-6 flex gap-3 flex-wrap">
            <span className="badge-sage" style={{ background: "rgba(255,255,255,0.1)", color: "#FAF8F5", borderColor: "rgba(255,255,255,0.2)" }}>
              <ShieldCheck className="w-3 h-3 inline mr-1" /> Vendor AYUSH Verified
            </span>
            <span className="badge-sage" style={{ background: "rgba(255,255,255,0.1)", color: "#FAF8F5", borderColor: "rgba(255,255,255,0.2)" }}>
              <Award className="w-3 h-3 inline mr-1" /> FSSAI Compliant Vendors
            </span>
          </div>
        </div>

        <div>
          <div className="font-serif text-lg font-semibold mb-3">Marketplace</div>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/products">All Products</Link></li>
            <li><Link to="/practitioners">Consult a Doctor</Link></li>
            <li><Link to="/practitioner/join">Join as Practitioner</Link></li>
            <li><Link to="/vendor/register">Become a Vendor</Link></li>
            <li><Link to="/vendor/agreement">Vendor Agreement</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-serif text-lg font-semibold mb-3">Support</div>
          <ul className="space-y-2 text-sm opacity-80 mb-4">
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/return-policy">Return Policy</Link></li>
            <li><Link to="/compliance">Compliance & Regulatory</Link></li>
          </ul>
          <div className="font-serif text-lg font-semibold mb-2">Legal Entity</div>
          <ul className="space-y-1 text-[11px] opacity-70 font-mono">
            <li>Amiroop Healthion LLP</li>
            <li>PAN · ABRFA1287H</li>
            <li>Incorporated · 05.02.2020</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs opacity-60 font-mono">
        © 2026 AMIROOP HEALTHION LLP · MARKETING & MARKETPLACE ONLY · NOT A MANUFACTURER
      </div>
    </footer>
  );
}
